import { ChangedCostsFilter, clampMinPct, MAX_CHANGED_COSTS_DAYS, parseDays } from '../../../../../reducers/gerenciadorPrecos/quickActionsFilter';

export { clampMinPct, MAX_CHANGED_COSTS_DAYS, parseDays };

export type DirectionOption = 'UP' | 'DOWN';

export const DIRECTION_OPTIONS: { label: string; value: DirectionOption }[] = [
  { label: 'Variação para cima', value: 'UP' },
  { label: 'Variação para baixo', value: 'DOWN' },
];

export const getDirectionValues = ({ directionUp, directionDown }: Pick<ChangedCostsFilter, 'directionUp' | 'directionDown'>): DirectionOption[] => {
  const directions: DirectionOption[] = [];

  if (directionUp) directions.push('UP');
  if (directionDown) directions.push('DOWN');

  return directions;
};

export const getNextDirections = (current: DirectionOption[], next: DirectionOption[]): DirectionOption[] => {
  if (!next.length) return current;

  return next;
};

// Ao menos uma direção precisa continuar marcada, então a última marcada é desabilitada.
export const isLastCheckedDirection = (directions: DirectionOption[], option: DirectionOption): boolean => {
  return directions.length === 1 && directions[0] === option;
};

type BuildChangedCostsFilterParams = {
  days: number | string;
  minPct: number;
  directions: DirectionOption[];
  isActive: boolean;
};

export const buildChangedCostsFilter = ({ days, minPct, directions, isActive }: BuildChangedCostsFilterParams): ChangedCostsFilter => ({
  isActive,
  value: parseDays(days),
  minPct: clampMinPct(minPct),
  directionUp: directions.includes('UP'),
  directionDown: directions.includes('DOWN'),
});
